import { useMediaQuery } from '@/shared/hooks'
import { getStorageItem, setStorageItem } from '@/shared/lib/storage/localStorage'
import { useCallback, useEffect, useState } from 'react'
import { THEME_STORAGE_KEY } from './constants'
import { Theme } from './types'

export const useThemeModel = () => {
  const isDarkPreferred = useMediaQuery('(prefers-color-scheme: dark)')

  const [theme, setTheme] = useState<Theme>(() =>
    getStorageItem<Theme>(THEME_STORAGE_KEY, isDarkPreferred ? 'dark' : 'light')
  )

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
    setStorageItem(THEME_STORAGE_KEY, theme)
  }, [theme])

  const toggleTheme = useCallback(() => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'))
  }, [])

  useEffect(() => {
    const savedTheme = getStorageItem<Theme | null>(THEME_STORAGE_KEY, null)
    if (!savedTheme) {
      setTheme(isDarkPreferred ? 'dark' : 'light')
    }
  }, [isDarkPreferred])

  return { theme, toggleTheme }
}
